import styled from 'styled-components';

export default styled.a`
  margin-left: 0.25rem;
  font-size: 14px;
`;
